import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-comments-dialog',
  template: `
    <div class="comments-dialog">
      <h2 mat-dialog-title>{{ data.title }}</h2>
      <mat-dialog-content>
        <p>{{ data.message }}</p>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Comments</mat-label>
          <textarea 
            matInput 
            [(ngModel)]="comments" 
            rows="4" 
            placeholder="Enter your comments here..."
            [required]="data.isRequired">
          </textarea>
          <mat-error *ngIf="data.isRequired && !comments">
            Comments are required for this action.
          </mat-error>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">Cancel</button>
        <button
          mat-raised-button
          [color]="data.action === 'reject' ? 'warn' : 'primary'"
          (click)="onSubmit()"
          [disabled]="data.isRequired && !comments">
          {{ data.action === 'approve' ? 'Approve' : (data.action === 'reject' ? 'Reject' : data.action) }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .comments-dialog {
      padding: 16px;
    }
    .full-width {
      width: 100%;
    }
    mat-form-field {
      margin-top: 16px;
    }
    textarea {
      min-height: 80px;
    }
  `],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class CommentsDialogComponent {
  comments: string = '';

  constructor(
    public dialogRef: MatDialogRef<CommentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string;
      message: string;
      isRequired: boolean;
      action: string;
    }
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.data.isRequired && !this.comments.trim()) {
      return;
    }
    this.dialogRef.close({ comments: this.comments.trim() });
  }
} 